import React from "react";
import "./BikeRentalData.css";

const BikeRentalData = () => {
  const YouTubePreview = ({ videoId }) => {
    const [play, setPlay] = React.useState(false);

    return (
      <div className="yt-container">
        {!play ? (
          <div className="yt-thumbnail" onClick={() => setPlay(true)}>
            <img
              src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
              alt="video thumbnail"
            />
            <div className="play-button"></div>
          </div>
        ) : (
          <iframe
            width="100%"
            height="350"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title="YouTube video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        )}
      </div>
    );
  };
  return (
    <div className="guidance-container">
      <h1 className="main-title">RENT A BIKE</h1>

      <div className="timeline">
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>1. Introduction</h3>

            <p>Rent a Bike – Ride Freely, Explore More</p>

            <p>
              Discover your destination with complete freedom using ZikRme Bike
              Rental Service.
            </p>

            <p>
              Whether you want to explore the city streets, ride through scenic
              roads, or enjoy a long adventure trip, ZikRme offers reliable and
              well-maintained bikes for every journey.
            </p>

            <p>
              With easy booking, flexible rental plans, and affordable pricing,
              renting a bike has never been simpler.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>2. About ZikRme Bike Rental Service</h3>

            <p>
              ZikRme provides convenient bike rental services for travelers and
              locals who want to explore destinations at their own pace.
            </p>

            <p>
              Our fleet includes comfortable and powerful bikes suitable for
              city rides as well as long-distance trips.
            </p>

            <p>
              All our bikes are regularly maintained, clean, insured, and ready
              for a smooth riding experience.
            </p>

            <p>
              With simple documentation and quick booking through platform, you
              can start your ride without any hassle.
            </p>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>3. Bikes Available for Rent</h3>
            <p>Choose a bike that suits your travel style.</p>
            <ul>
              <li>
                <b>Scooty</b> – Perfect for local city travel and short rides.
              </li>
              <li>
                <b>Standard Bikes</b> – Comfortable for daily commuting and city
                exploration.
              </li>
              <li>
                <b>Royal Enfield</b> – Best for long rides, highway travel, and
                adventure trips.
              </li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>4. Features of ZikRme Bike Rental</h3>

            <ul>
              <li>Well-maintained and clean bikes</li>
              <li>Insured vehicles for safe riding</li>
              <li>Easy documentation process</li>
              <li>Affordable rental pricing</li>
              <li>Flexible pickup and return timing</li>
              <li>Roadside assistance available on call</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>5. Rental Plans</h3>
            <p>We offer flexible rental options based on your travel needs.</p>
            <ul>
              <li>
                <b>Hourly Rental</b> – Perfect for short city rides.
              </li>
              <li>
                <b>Daily Rental</b> – Best for exploring the city or nearby
                places.
              </li>
              <li>
                <b>Weekly Rental</b> – Ideal for longer trips and travel plans.
              </li>
              <li>Doorstep Delivery & Pickup (Available on request)</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>6. Documents Required</h3>
            <p>To rent a bike, you need:</p>
            <ul>
              <li>Valid Driving License</li>
              <li>Government ID Proof (Aadhaar / Passport / Voter ID)</li>
              <li>Security Deposit (Refundable)</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>7. Why Choose ZikRme Bike Rental?</h3>

            <ul>
              <li>Affordable pricing with no hidden charges</li>
              <li>Easy booking through Platform</li>
              <li>Reliable and well-maintained bikes</li>
              <li>Flexible rental durations</li>
              <li>Trusted by travelers and locals</li>
              <li>Customer support available for assistance</li>
            </ul>
          </div>
        </div>

        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>8. How to Rent a Bike</h3>
            <p>Renting a bike with ZikRme is simple.</p>
            <ul>
              <li>Choose your preferred bike</li>
              <li>Select rental duration (Hourly / Daily / Weekly)</li>
              <li>Share pickup location and travel date</li>
              <li>Confirm booking and start your ride</li>
            </ul>
          </div>
        </div>
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>9.How to Rent a Bike on ZikRme</h3>
            <p>
              New to ZikRme? Watch our quick tutorial to learn how to rent a
              bike easily.
            </p>
            <YouTubePreview videoId="dQw4w9WgXcQ" />
            <p>In this video you will learn:</p>
            <ul>
              <li>How to choose a bike for rent</li>
              <li>Rental pricing and plans</li>
              <li>Required documents for booking</li>
              <li>How to confirm your booking</li>
            </ul>
          </div>
        </div>
        <div className="timeline-item">
          <div className="circle"></div>
          <div className="content">
            <h3>10.Start Your Ride Now</h3>
            <p>Book Your Bike Instantly</p>
            <p>👉 Click to Rent</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BikeRentalData;
